module.exports = __webpack_public_path__ + "static/img/culture_icon_12.584a189f.svg";